import { defineSlotRecipe } from "@chakra-ui/react";

export const selectSlotRecipe = defineSlotRecipe({
  className: "chakra-select",
  slots: ["trigger"],
  variants: {
    visual: {
      outline: {
        trigger: {
          bg: "transparent",
          borderWidth: "1px",
          borderColor: "neutral.400",
          _expanded: {
            borderColor: "border.emphasized",
          },
        },
      },
    },
  },
});
